/**
 * Returns a lowercase string with only the first character set in uppercase.
 */
export default function capitalize(s: string): string {
    return s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : '';
}
